module.exports = __webpack_public_path__ + "static/media/digger.48fec855.svg";